import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://aqvmbtvppxhgdeygxcut.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFxdm1idHZwcHhoZ2RleWd4Y3V0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODU1NjQxNjUsImV4cCI6MjEwMTE0MDE2NX0._020GwSThOYS5_vfsJM_Mf3KOEmeewfpZxub3BW2OmA';

export const supabase = createClient(
  SUPABASE_URL,
  SUPABASE_ANON_KEY
);